"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.send = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_SimulationSync;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.writeBool(m, d.isRunning);
    messageWriter_sidecar_1.messageWriter.write32(m, d.synced_idCounter);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        isRunning: messageWriter_sidecar_1.messageWriter.readBool(m),
        synced_idCounter: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        isRunning: true,
        synced_idCounter: 1000001,
    };
    messageWriter_sidecar_1.messageWriter.test('simulationSync', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    // console.log('process simulation frame')
    var msg = read(m);
    // TODO: does this work for the host?
    if (!voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        diveSimulationManager_sidecar_1.diveSimulationManager.get().synced_idCounter = msg.synced_idCounter;
    }
    if (msg.isRunning) {
        diveSimulationManager_sidecar_1.diveSimulationManager.setMode('game');
    }
    diveSimulationManager_sidecar_1.diveSimulationManager.setIsRunning(msg.isRunning); // Should do a reset on frame counter, etc.
    if (msg.isRunning) {
        // TODO: pretty hacky
        voyageGameManager_sidecar_1.voyageGameManager.goGame();
    }
}
exports.process = process;
function send(isRunning) {
    sendMessageToAll({
        isRunning: isRunning,
        synced_idCounter: diveSimulationManager_sidecar_1.diveSimulationManager.get().synced_idCounter,
    });
}
exports.send = send;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
